<template>
  <div class="tile is-parent is-vertical">
    <p class="formtitle">Escolas >> {{formtitle}}</p>

    <article class="tile is-child notification formbox">
      <form @submit.prevent="validate">
        <b-field grouped group-multiline>
          <b-field
            class="column is-4"
            label="cnpj"
            :type="{'is-danger': errors.has('cnpj')}"
            :message="errors.first('cnpj')"
          >
            <b-input
              v-model="escola.cnpj"
              v-cleave="masks.cnpj"
              v-validate="'required'"
              name="cnpj"
            ></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="nome"
            :type="{'is-danger': errors.has('nome')}"
            :message="errors.first('nome')"
          >
            <b-input v-model="escola.nome" v-validate="'required'" name="nome"></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="telefone"
            :type="{'is-danger': errors.has('telefone')}"
            :message="errors.first('telefone')"
          >
            <b-input
              v-model="escola.telefone"
              v-validate="'required'"
              v-cleave="masks.telefone"
              name="telefone"
            ></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="email"
            :type="{'is-danger': errors.has('email')}"
            :message="errors.first('email')"
          >
            <b-input v-model="escola.email" v-validate="'required|email'" name="email"></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="valor"
            :type="{'is-danger': errors.has('valor')}"
            :message="errors.first('valor')"
          >
            <b-input v-model="escola.valor" v-validate="'required'" name="valor"></b-input>
          </b-field>

          <b-field label="Corretor Externo" class="column is-4">
            <b-tooltip type="is-dark" label="Quando a escola usa os corretores da RedOnline esse campo tem que estar ativado">
              <b-icon size="is-small" icon="help-circle-outline"></b-icon>
            </b-tooltip>
            <b-switch
              true-value="1"
              false-value="0"
              v-model="escola.escola_externo"
              type="is-success"
            ></b-switch>
          </b-field>

          <b-field
            class="column is-4"
            label="creditos"
            :type="{'is-danger': errors.has('credito')}"
            :message="errors.first('credito')"
          >
            <b-input v-model="escola.credito" v-validate="'required'" name="credito"></b-input>
          </b-field>

          <b-field
            class="column is-4"
            label="credito ultilizado"
            :type="{'is-danger': errors.has('credito_ultilizado')}"
            :message="errors.first('credito_ultilizado')"
          >
            <b-input
              v-model="escola.credito_ultilizado"
              name="credito_ultilizado"
            ></b-input>
          </b-field>
        </b-field>

        <div class="control has-text-centered">
          <b-button class="button cancelbutton">Cancelar</b-button>
          <button type="submit" class="button updatebutton" :disabled="!isFormValid">{{buttom}}</button>
        </div>
      </form>
    </article>
  </div>
</template>
<script>
export default {
  data() {
    return {
      masks: {
        cnpj: {
          delimiters: [".", ".", "/", "-"],
          blocks: [2, 3, 3, 4, 2],
          numericOnly: true
        },
        telefone: {
          blocks: [2, 4, 4],
          numericOnly: true
        }
      }
    };
  },
  name: "escolaForm",
  props: ["escola", "buttom", "formtitle"],
  methods: {
    validate() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let self = this;

          this.$emit("formSubmit", self.escola, () => {});
        }
      });
    }
  },
  components: {},
  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some(key => this.fields[key].invalid);
    }
  },
  created() {}
};
</script>
<style scoped>
.switch {
  margin-top: 40px;
  margin-left: -163px;
}
</style>